import { Chip, Stack } from "@mui/material";
import TitleHeading from "./title-heading";
import TitleDescription from "./title-description";

const Title1 = ({
    title,
    description,
    chipLabel="",
    chipIcon=null,
    chipColor
}) => {
    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='center'
                sx={{
                    width: '100%',
                    pb: {xs: 2, md: 5}
                }}
                spacing={{xs: 1, md: 1.5}}
            >
                <TitleHeading 
                    title={title} 
                    textAlign="center"
                    chipLabel={chipLabel}
                    chipIcon={chipIcon}
                    chipColor={chipColor}
                    chipAlignment="center"
                />

                <TitleDescription description={description} textAlign="center"/>
            </Stack>
        </>
    );
}

export default Title1;